import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container py-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold" }, [
  /*#__PURE__*/_createTextVNode(" New "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gradient" }, "Videos")
], -1)
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 xl:gap-6 mt-6" }
const _hoisted_4 = { class: "p-4" }

import VideoCart from "@/components/VideoCart.vue";
import ChannelCart from "@/components/ChannelCart.vue";
import { Ref, ref } from "vue";
import fetchDataFromApi from "@/api/api";
import LoadingSkeleton from "@/components/LoadingSkeleton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const videos: Ref<null | Video[] | Channel[]> = ref(null);

const getVideos = async () => {
  try {
    const data = await fetchDataFromApi("/search", {
      q: "New",
      part: "snippet,id",
    });
    videos.value = data.items;
  } catch (error) {
    console.log(error);
  }
};

getVideos();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!videos.value)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList([...Array(20)], (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "bg-bg_secondary",
              key: item
            }, [
              _createVNode(LoadingSkeleton, { class: "aspect-[3/2]" }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(LoadingSkeleton, { class: "rounded-full w-full h-5" }),
                _createVNode(LoadingSkeleton, { class: "rounded-full w-full max-w-[150px] h-5 mt-3" }),
                _createVNode(LoadingSkeleton, { class: "rounded-full w-full max-w-[170px] h-3 mt-3" })
              ])
            ]))
          }), 128))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(videos.value, (video, i) => {
            return (_openBlock(), _createElementBlock("div", { key: i }, [
              (video.id.kind === 'youtube#video')
                ? (_openBlock(), _createBlock(VideoCart, {
                    key: 0,
                    video: video
                  }, null, 8, ["video"]))
                : (_openBlock(), _createBlock(ChannelCart, {
                    key: 1,
                    channel: video
                  }, null, 8, ["channel"]))
            ]))
          }), 128))
    ])
  ]))
}
}

})